import React, { forwardRef, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import useModalContext from 'components/context/modal'
import Button from 'components/base/button'
import { FormGroup, InputGroup } from '@blueprintjs/core'
import treesApi from '../../api/trees'

const ImportGedcomFileInput = (props) => {
  const modalContext = useModalContext()

  const fileInputRef = useRef(null)

  const handleOImportTreeClick = () => {
    fileInputRef.current.click()
  }

  const importFamilyRef = useRef()

  const onFileChange = async (e) => {
    if (e.target.files) {
      modalContext.spinner(<>We are processing your GEDCOM file, it can takes a while.</>, {
        title: 'Import GEDCOM file',
      })

      const { data: tree, error: treeError } = await treesApi(props.accessToken).importGedcomFile(
        e.target.files[0],
      )

      modalContext.hideSpinner()

      if (tree) {
        try {
          gtag('event', 'import_gedcom_file', {
            event_category: 'trees',
            number_of_persons: tree.person_count,
          })
        } catch (e) {
          console.error(e)
        }

        modalContext.show(
          <ImportFamilyModal
            ref={importFamilyRef}
            name="New Family Tree"
            numberOfPersons={tree.person_count}
            errors={tree.errors ?? []}
          />,
          {
            title: `Import GEDCOM file`,
            closeable: false,
            className: 'mw-660',
            footer: ({ close }) => {
              const handleUpdateFamilyTreeName = async () => {
                await treesApi(props.accessToken).updateTree(
                  tree.tree_id,
                  importFamilyRef.current.treeName,
                )
                props.onSuccess()
                close()
              }

              return (
                <Button type="primary" onClick={handleUpdateFamilyTreeName}>
                  Save
                </Button>
              )
            },
          },
        )
      } else {
        try {
          gtag('event', 'import_gedcom_file_error', {
            event_category: 'trees',
          })
        } catch (e) {
          console.error(e)
        }

        console.error(treeError)
        modalContext.confirm(
          'An error occurred while importing the file. This is likely due to an invalid GEDCOM file format. Please verify your file and try again.',
          {
            title: 'Import GEDCOM file',
            closeable: false,
            confirmLabel: 'OK',
          },
        )
      }
    }

    fileInputRef.current.value = ''
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        className="d-none"
        accept=".ged, .gedcom"
        onChange={onFileChange}
      />
      {props.trigger({ onClick: handleOImportTreeClick, isProcessing: false })}
    </>
  )
}

ImportGedcomFileInput.propTypes = {
  accessToken: PropTypes.string,
  onSuccess: PropTypes.func,
  trigger: PropTypes.func,
}

export default ImportGedcomFileInput

const ImportFamilyModal = forwardRef((props, ref) => {
  const [treeName, setTreeName] = useState(props.name)

  useEffect(() => {
    ref.current = {
      treeName,
    }
  }, [treeName])

  return (
    <>
      <FormGroup labelFor="familyCaption" label="Name of your new family tree">
        <InputGroup
          id="familyCaption"
          placeholder="Enter the name of your tree"
          value={treeName}
          onChange={(e) => setTreeName(e.target.value)}
        />
      </FormGroup>
      Your family tree was successfully processed. We imported {props.numberOfPersons} individuals.
      {props.errors.length > 0 && (
        <>
          <br />
          <br />
          However, we encountered {props.errors.length} issue(s) with the file. Please check the log
          for more details.
          <br />
          <pre
            className="text-danger small w-100 mt-1"
            style={{ maxHeight: 250, overflow: 'auto' }}
          >
            {props.errors.join('\n')}
          </pre>
        </>
      )}
    </>
  )
})
